<template>
    <div class="MyCourse">
        <div class="top_title">
            <h3>共{{totalPage}}门课程</h3>
            <div class="yearBox">
                <span :class="{'light': light === 0}" @click="changeSort(0)">全部</span>
                <span v-for="(item, index) in yearList" :key="item" :class="{'light': light === index + 1}" @click="changeSort(index, item)">{{item}}</span>
            </div>
            <!-- 移动端下拉框 -->
            <div class="dropdown">
                <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{ dropdownVal }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="false">全部</el-dropdown-item>
                        <el-dropdown-item v-for="item in yearList" :key="item" :command="item">{{item}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <!-- 列表 -->
        <ul class="listWrap">
            <li v-for="(item,index) in myCourseList" :key="index">
                <router-link :to="{path:'/classDetial', query:{courseId:item.CourseID}}" @click.native="saveID(item.CourseID)">
                    <div class="picBox">
                        <img :src="item.ImgPath" />
                        <p><span>{{item.Score}}</span><span>学分</span></p>
                    </div>
                    <div class="infoWrap">
                        <p class="category"><span>{{item.Keywords}}</span></p>
                        <h2>{{item.Title}}</h2>
                        <div class="info">
                            <p>时长：<span>{{item.Duration}}</span></p>
                            <p>播放：<span>{{item.Hits}}</span></p>
                            <p>日期：<span>{{item.PubDate | formatData}}</span></p>
                        </div>
                    </div>
                    <div class="head-zan">
                        <p class="head"><img src="../../assets/img/speaker.jpg" /><span>{{item.LectureName}}</span></p>
                        <div class="zan"><p><img src="../../assets/img/zanBefore.svg" /></p><span>{{item.Tags}}</span></div>
                    </div>
                </router-link>
                <div class="study">
                    <router-link :to="{path:'/playVideo', query:{courseId:item.CourseID,classId:item.ClassID,PersonLessonId:item.CurLessonID}}" class="beginStudy"><img src="../../assets/img/study.svg" /><span>继续学习</span></router-link>
                    <p class="UseTime"><span>{{'已学习至'+item.Process+'%'}}</span></p>
                </div>
            </li>
        </ul>
        <!-- 分页器 -->
        <div class="page"><Pagination :total='totalPage' :page="page" :pageSize = 'pagesize' @currentPage="currentPage"></Pagination></div>
        <!-- 移动端 -->
        <p class="moreCourse" v-if="isShowMore" @click="getMore">查看更多</p>
    </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import '../../assets/js/formatTime'
export default {
    data() {
        return {
            light: 0,  // 是否被选中
            year: 2021,
            all: true,
            dropdownVal: '全部',
            myCourseList:[],  // 课程列表
            totalPage:0,  // 总页数
            page:1,  // 页数
            pagesize:9,  // 多少条数据
            isShowMore:true,  // 移动端的查看更多
			yearList: []
        }
    },
    mounted() {
		// 获取年份列表
		this.yearList = this.getYearsFn()
        // 获取课程列表
        this.getCourseList();
    },
    methods: {
		// 获取年份
		getYearsFn() {
			let nowYear = new Date().getFullYear()
			let list = []
			for(let i = 2020; i <= nowYear; i ++) {
				list.push(i)
			}
			return list.reverse()
		},
        // 获取课程列表
        getCourseList(type){
            let timestamp = Date.parse(new Date())/1000;
            let data = this.all ? {
                "TimeStamp":timestamp,
                "PageSize":this.pagesize,
                "CurPage":this.page
            } : {
                "TimeStamp":timestamp,
                "PageSize":this.pagesize,
                "CurPage":this.page,
                "Query": [
                   {"Item":"DateRange","Value": this.year + '-01-01_' + this.year + '-12-31'}
                ]
            };
            this.$axios.post(Const_Api_Root+'api/Member/MyClasses',data,{
				contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    // 总数
                    this.totalPage = res.data.Data.Total;
                    if(type == 'more'){
                        // 移动端的操作
                        this.myCourseList = this.myCourseList.concat(res.data.Data.Rows);
                    }else{
                        // 列表
                        this.myCourseList = res.data.Data.Rows;
                    }

                    // 是否显示查看更多
                    if(this.totalPage != this.myCourseList.length){
                        this.isShowMore = true;
                    }else{
                        this.isShowMore = false;
                    }
                    // 格式化关键词
                    for(let i=0;i<this.myCourseList.length;i++){
                        let keyWord = this.myCourseList[i].Keywords;
                        if(keyWord != undefined){
                            this.myCourseList[i].Keywords = keyWord.toString();
                        }
                    }
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 分页器
        currentPage(index){
            this.page = index;
            this.getCourseList();
        },
        // 移动端的获取更多
        getMore(){
            this.page++;
            this.getCourseList('more');
        },
        // 保存id
        saveID(id){
            sessionStorage.setItem('courseID',id);
            sessionStorage.setItem('returnPage','MyCourse');
        },
        // pc年份选择
        changeSort(n, y) {
            this.light = n + 1;
            this.page = 1;
            if(y) {
                this.year = y;
                this.all = false;
            }else {
                this.all = true;
            }
            this.getCourseList();
        },
        // 下拉框
        handleCommand(command) {
            if(!command) {
                this.all = true;
            }else {
                this.year = command;
                this.all = false;
            }
            this.dropdownVal = command;
            this.page = 1;
            this.getCourseList();
        }
    },
    filters: {
        // 格式化时间
        formatData:(value) => {
            value = new Date(value).Format("yyyy-MM-dd")
            return value;
        }
    },
    components: {
        Pagination
    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px) {
    // 查看更多
    .moreCourse{
        font-size: 14px;
        color: #0061FE;
        text-align: center;
        font-weight: bold;
        padding: 20px 0;
    }
    .page{
        display: none;
    }
    .listWrap{
        justify-content: center;
        li{
            width: 100%;
            margin-bottom: 30px;
            // .picBox,.picBox img{
            //     max-height: 400px;
            // }
        }
    }
    .top_title{
        margin: 30px 0;
        h3{
            font-size: 12px;
        }
        .yearBox{
            display: none;
        }
    }
}
@media screen and (min-width: 1445px) {
    .dropdown,.moreCourse{
        display: none;
    }
    .MyCourse{
        width: 1200px;
        margin: 60px auto 28px;
        .top_title{
            h3{
                font-size: 20px;
                margin-right: 70px;
            }
            span{
                font-size: 16px;
                color: rgba(25,25,26,0.80);
                line-height: 16px;
                margin-left: 30px;
                cursor: pointer;
            }
            .light{
                color: #19191A;
                font-weight: bold;
            }
        }
    }
    .listWrap{
        li{
            margin: 30px 30px 30px 0;
            width: 31.5%;
            &:nth-child(3n){
                margin-right: 0;
            }
            .picBox img{
                height: 250px;
            }
        }
    }
}
@media screen and (min-width: 1029px) and (max-width: 1440px){
    .dropdown,.moreCourse{
        display: none;
    }
    .MyCourse{
        width: 1100px;
        margin: 60px auto 28px;
        .top_title{
            h3{
                font-size: 20px;
                margin-right: 70px;
            }
            span{
                font-size: 16px;
                color: rgba(25,25,26,0.80);
                line-height: 16px;
                margin-left: 30px;
                cursor: pointer;
            }
            .light{
                color: #19191A;
                font-weight: bold;
            }
        }
    }
    .listWrap{
        li{
            margin: 30px 30px 30px 0;
            width: 31.5%;
            &:nth-child(3n){
                margin-right: 0;
            }
            .picBox img{
                height: 250px;
            }
        }
    }
}
// 公用
.MyCourse{
    .top_title{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}
.listWrap{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    li{
        .picBox{
            width: 100%;
            height: auto;
            position: relative;
            img{
                width: 100%;
                height: 250px;
                border-radius: 16px;
            }
            p{
                background: #0061FE;
                border-radius: 16px 0 16px 0;
                color: #fff;
                width: 63px;
                height: 60px;

                position: absolute;
                right: 0;
                bottom: 0;
                span{
                    display: block;
                    text-align: center;
                }
                span:first-child{
                    font-size: 24px;
                    margin-top: 4px;
                }
                span:last-child{
                    font-size: 12px;
                }
            }
        }
    }
    .infoWrap{
        width: 100%;
        max-width: 100%;
        padding-left: 15px;
        h2{
            font-size: 20px;
            color: #19191A;
            font-weight: bold;
            overflow: hidden; 
            text-overflow: ellipsis;
            white-space: nowrap; 
        }
        .info{
            font-size: 14px;
            color: rgba(25,25,26,0.80);
            display: flex;
            margin: 10px 0 20px;
            p{
                margin-right: 10px;
            }
        }
    }
    .head-zan{
        display: flex;
        align-items: center;
        padding-left: 15px;
        img{
            width: 24px;
            height: 24px;
        }
        .head{
            font-size: 14px;
            color: rgba(25,25,26,0.80);
            img{
                border-radius: 50%;
                margin-right: 10px;
                vertical-align: middle;
            }
        }
        .zan{
            display: flex;
            align-items: center;
            font-size: 12px;
            color: rgba(25,25,26,0.80);
            p{
                width: 24px;
                height: 24px;
                margin: 0 10px 0 30px;
            }
        }
    }
    .category{
        font-size: 12px;
        color: #0061FE;
        margin: 30px 0 20px;
        span{
            margin-right: 10px;
        }
    }
}
.study{
    display: flex;
    align-items: center;
    margin-top: 30px;
    .beginStudy{
        display: block;
        width: 160px;
        line-height: 44px;
        text-align: center;
        background: #0061FE;
        box-shadow: 0 24px 24px 0 rgba(0,97,254,0.20);
        border-radius: 22px;
        font-size: 16px;
        color: #FFFFFF;
        &:hover{
            background: #4089FF;
        }
        img{
            width: 20px;
            height: 20px;
            margin-right: 11px;
            vertical-align: middle;
        }
    }
    .UseTime{
        font-size: 16px;
        color: #0061FE;
        margin-left: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenter/MyCourse.vue